module.exports = __webpack_public_path__ + "media/img/help_center/Student_Manage_Application_02-0f583d22745844a4da65d50da83d5b1d.jpg";